// 获取当前国际化状态封装在了上面的./langs/index.js中，相当于是初始化国际化
import { i18n, getLanguage } from '@/i18n/index'
const state = {
  language: getLanguage(),
}
const mutations = {
  SET_LANGUAGE: (state, lang) => {
    state.language = lang
    i18n.locale = lang // 修改页面需要显示的语言
    localStorage.setItem('language', lang)
  },
}
const actions = {}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
